import { Component, OnInit } from '@angular/core';

import { VacanciesService , CandidatesService, AuthService} from '../../services'
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-vacancy',
    templateUrl: './vacancy.component.html',
    styleUrls: ['./vacancy.component.scss']
})
export class VacancyComponent implements OnInit {
	vacancy = null;
	vacancy_id = 0;
	canApply = false;
	applied = [];

    constructor(private toastr: ToastrService, private vacanciesService: VacanciesService,private route: ActivatedRoute, private candidateService : CandidatesService, private authService : AuthService) {
    	this.route.params.subscribe( params => {
	      this.vacancy_id = params.id
	    });
    }

    ngOnInit() {
    	if(this.authService.user)
	    	this.candidateService.get(this.authService.user.candidate?.id).subscribe((res: any)=>{
	    		if(res.data.profile_reference_id != null)
	    			this.canApply = true;
	    		this.applied = res.data.vacancies.filter(r=>{return r.vacancy_id == this.vacancy_id});
	    		this.vacanciesService.get(this.vacancy_id).subscribe((res: any)=>{this.vacancy = res.data})
	    	})
	    else
	    	this.vacanciesService.get(this.vacancy_id).subscribe((res: any)=>{this.vacancy = res.data})
    }

    Apply(){
    	this.candidateService.applyToJob(this.authService.user.candidate?.id,this.vacancy_id).subscribe((res: any)=>{
    		this.applied = [res];
    		this.toastr.success("You Applied To "+this.vacancy.job.job_title_en+" Successfully", "Job Apply");
    	})
    }
}
